"use strict";
/**
 * ibantools-germany
 * Copyright (C) 2022-2023 Markus Baumer <markus@baumer.dev>
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.

 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.

 * You should have received a copy of the GNU Affero General Public License
 * along with this program.  If not, see <https://www.gnu.org/licenses/>.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.Result = void 0;
/**
 * These are different response values for validate functions.
 *
 * If you use the isSomethingValid functions you will receive a boolean true
 * if the result is either VALID or NO_CHECK_DIGIT_CALCULATION
 */
var Result;
(function (Result) {
    /**
     * Something is invalid
     */
    Result["INVALID"] = "INVALID";
    /**
     * Check digit calculation method isn't implemented because it no bank
     * currently uses it.
     */
    Result["METHOD_NOT_IMPLEMENTED_NOT_IN_USE"] = "METHOD_NOT_IMPLEMENTED_NOT_IN_USE";
    /**
     * The bank uses no check digit method for some or all account numbers.
     * So we can't test if the account number is wrong and have to treat it
     * as valid.
     */
    Result["NO_CHECK_DIGIT_CALCULATION"] = "NO_CHECK_DIGIT_CALCULATION";
    /**
     * Check digit calculation method is not known
     */
    Result["UNKOWN_CHECK_DIGIT_CALCULATION_METHOD"] = "UNKOWN_CHECK_DIGIT_CALCULATION_METHOD";
    /**
     * All validations were successful
     */
    Result["VALID"] = "VALID";
})(Result || (exports.Result = Result = {}));
